import { CartLinesUpdateEvent } from '@shopify/events';
import { buildPairedLineUpdates } from '@theme/koffer-bundle-core';

const pendingUpdates = new Map();

function requestJson(url, body) {
  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.open('POST', url);
    request.responseType = 'json';
    request.setRequestHeader('Accept', 'application/json');
    request.setRequestHeader('Content-Type', 'application/json');
    request.onload = () => {
      const data = request.response ?? {};
      if (request.status >= 200 && request.status < 300 && !data.errors) resolve(data);
      else reject(new Error(data.errors || `HTTP ${request.status}`));
    };
    request.onerror = () => reject(new Error('Warenkorb-Anfrage fehlgeschlagen'));
    request.send(JSON.stringify(body));
  });
}

/** @param {Event} event */
function handleQuantityUpdate(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const selectedRow = target.closest('[data-key][data-bundle-id]');
  const bundleId = selectedRow?.dataset.bundleId;
  const selectedKey = selectedRow?.dataset.key;
  const quantity = Number(event.detail?.quantity);
  if (!bundleId || !selectedKey || !Number.isFinite(quantity)) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const previous = pendingUpdates.get(bundleId);
  if (previous) window.clearTimeout(previous);
  pendingUpdates.set(
    bundleId,
    window.setTimeout(() => {
      pendingUpdates.delete(bundleId);
      updatePair(selectedKey, quantity);
    }, 300)
  );
}

/** @param {MouseEvent} event */
function handleRemoveClick(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const removeButton = target.closest('button[data-bundle-remove]');
  const selectedRow = removeButton?.closest('[data-key][data-bundle-id]');
  const selectedKey = selectedRow?.dataset.key;
  if (!selectedKey) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  updatePair(selectedKey, 0);
}

async function updatePair(selectedKey, quantity) {
  const cartComponents = Array.from(document.querySelectorAll('cart-items-component'));
  const primaryComponent = cartComponents.find((component) => component.querySelector(`[data-key="${CSS.escape(selectedKey)}"]`));
  if (!primaryComponent) return;

  const rows = Array.from(primaryComponent.querySelectorAll('[data-key]')).map((row) => ({
    key: row.dataset.key,
    bundleId: row.dataset.bundleId,
  }));
  const updates = buildPairedLineUpdates(rows, selectedKey, quantity);
  const sections = cartComponents.map((component) => component.dataset.sectionId).filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();
  const lines = Object.entries(updates).map(([id, updatedQuantity]) => ({ id, quantity: updatedQuantity }));

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: quantity > 0 ? 'update' : 'remove',
      context: 'cart',
      lines,
      promise: deferred.promise,
    })
  );

  for (const component of cartComponents) component.classList.add('cart-items-disabled');

  try {
    const data = await requestJson(Theme.routes.cart_update_url, {
      updates,
      sections: sections.join(','),
      sections_url: window.location.pathname,
    });

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(data),
      detail: {
        items: data.items,
        itemCount: data.item_count,
        sections: data.sections,
        source: 'koffer-bundle-cart-sync',
        didError: false,
      },
    });
  } catch (error) {
    deferred.reject(error);
    console.error('[koffer-bundle-cart-sync]', error);
    window.location.reload();
  } finally {
    for (const component of cartComponents) component.classList.remove('cart-items-disabled');
  }
}

document.addEventListener('quantity-selector:update', handleQuantityUpdate, { capture: true });
document.addEventListener('click', handleRemoveClick, { capture: true });
